const Joi = require("joi");

const menuSchema = (data) => {
  const schema = Joi.object({
    // label: Joi.string()
    //   .trim()
    //   .pattern(new RegExp("^[a-zA-Z0-9 -]*$"))
    //   .required()
    //   .messages({
    //     "string.pattern.base":
    //       "Only letters, numbers, spaces, hyphens (-), ampersands (&), parentheses (), and periods (.) are allowed.",
    //     "string.empty": "Please enter Menu Name.",
    //     "any.required": "Please enter Menu Name.",
    //   }),
    label: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?:[- ][a-zA-Z0-9]+)*$"))
      .required()
      .messages({
        "string.pattern.base":
          "Only letters, numbers, spaces, and hyphens (-) are allowed. Hyphens cannot be at the start or end.",
        "string.empty": "Please enter Menu Name.",
        "any.required": "Please enter Menu Name.",
      }),

    url: Joi.when("routeMethod", {
      is: "external",
      then: Joi.string()
        .trim()
        .uri({ scheme: [/https?/] }) // only required when external
        .required()
        .messages({
          "string.uri": "Please enter a valid URL.",
          "string.empty": "Please enter URL.",
          "any.required": "Please enter URL.",
        }),
      otherwise: Joi.string().trim().allow("").messages({
        "string.uri": "Please enter a valid URL.",
      }),
    }),

    // target: Joi.string().required().messages({
    //   "number.base": "Please select target.",
    //   "any.only": "Please select target.",
    //   "any.required": "Please select target.",
    //   "string.empty": "Please select target.",
    // }),

    order: Joi.number()
      .integer()
      .max(999) // not exceed 3 digits
      .allow(null, "")
      .messages({
        "number.base": "Order must be a number.",
        "number.max": "Order cannot exceed 3 digits.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = menuSchema;
